import axios from '../axios';

/**
 * 根据订单号 查询订单状态
 * @param {*} params
 * out_trade_no	是	String	支付订单号
 * @wiki   http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059867  20220530
 */
export const getPayState = params => {
  return axios({
    url: '/api/pay/searchOrder',
    params
  })
}
/**
 * 获取 微信支付二维码
 * @param {*} params 
 * total	是	int	支付金额
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12058846  20220530
 */
export const getQRPayWechat = params => {
  return axios({
    url: '/api/pay/NativeOrder',
    params
  })
}
/**
 * 导出 驾校账户 （平台）
 * @param {*} data 
 * areaCode	否	string	区域编码
    schoolName	否	string	驾校名称
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059791  20220523 
 */
export const exportExcelForPlatForm = data => {
  return axios({
    url: '/balance/exportBalancelist',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
/**
 * 导出 账户管理
 * @param {*} data 
    pageNum	否	string	页码
    pageSize	否	string	页数
    orderNo	否	string	订单id
    studentName	否	string	学员姓名
    idcard	否	string	身份证号
    trainType	否	string	报考车型 A1，A2
    state	否	string	状态 0:待支付1:已支付 2:交易成功3:申请退款4:退款成功5:订单关闭
    payBeginTime	否	string	2022-05-21 12:20:41
    payEndTime	否	string	2022-05-21 12:20:41
    schoolName	否	string	培训机构
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059745  20220523
 */
export const exportExcel = data => {
  return axios({
    url: '/order/exportBalanceExcel',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
/**
 * 分页查询 充值记录列表
 * @param {*} data 
 * schoolId	否	string	驾校id
    beginDate	否	string	充值开始时间 2022-05-20 12:20:41
    endDate	否	string	充值结束时间 2022-05-21 12:20:41
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059725  20220523
 */
export const pageRechargeRecord = data => {
  return axios({
    url: '/investrecord/list',
    method: 'post',
    data,
  })
}
/**
 * 充值
 * @param {*} data 
 * schoolId	是	string	驾校id
    balanceAmount	是	string	充值金额(元)
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059720  20220523 
 */
export const recharge = data => {
  return axios({
    url: '/balance/save',
    method: 'post',
    data
  })
}
/**
 * 获取账户余额（驾校）
 * @param {*} data 
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059749  20220523
 */
export const getBalanceForSchool = data => {
  return axios({
    url: '/balance/getBalance',
    method: 'post',
    data
  })
}
/**
 * 分页查询驾校账户列表
 * @param {*} data 
  pageNum	否	string	页码
  pageSize	否	string	页数
  orderNo	否	string	订单id
  studentName	否	string	学员姓名
  idcard	否	string	身份证号
  trainType	否	string	报考车型 A1，A2
  state	否	string	状态 0:待支付1:已支付 2:交易成功3:申请退款4:退款成功5:订单关闭
  payBeginTime	否	string	2022-05-21 12:20:41
  payEndTime	否	string	2022-05-21 12:20:41
  schoolName	否	string	培训机构
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059740  20220523
 */
export const pageSchoolAccount = data => {
  return axios({
    url: '/order/useBalanceList',
    method: 'post',
    data,
  })
}
/**
 * 分页查询平台 账户列表
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059766  20220523 
 */
export const pagePlatformAccount = data => {
  return axios({
    url: '/balance/list',
    method: 'post',
    data
  })
}


/**
 * 分页查询平台 充值凭证
 * @param {*} data 
 * id:id
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19172369   
 */
export const viewCredentials = data => {
  return axios({
    url: '/investrecord/viewCredentials',
    method: 'post',
    data
  })
}
/**
 * @财务管理平台驾校充值记录补充凭证
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19172684  20221016
 */
export const supplementaryVouchers = data => {
  return axios({
    url: '/investrecord/supplementaryVouchers',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/financial.js